<template>
    <div>
        <div style="display: flex; justify-content: space-between" v-loading="!view">
            <h1 style="margin-bottom: 20px; display: flex; align-items: center">
                {{ title }}
                <el-select v-model="selected_view_id" style="margin: 0 5px 0 20px;" @change="() => changeView()" filterable>
                    <el-option-group label="Recent">
                        <el-option :value="v.id" :key="v.id" :label="v.name" v-for="v in recent"/>
                    </el-option-group>
                    <el-option-group label="All">
                        <el-option :value="v.id" :key="v.id" :label="v.name" v-for="v in alpha"/>
                    </el-option-group>
                </el-select>
                <btn cssClass="btn btn-xs btn-success" icon="fas fa-thumbtack" v-if="view && view.is_pinned" :click="() => unpin(view)"></btn>
                <btn cssClass="btn btn-xs btn-secondary" icon="fas fa-thumbtack" v-if="view && !view.is_pinned" :click="() => pin(view)"></btn>
            </h1>
            <div>
                <slot name="search-input"></slot>

                <el-dropdown trigger="click" @command="settingsCommand">
                    <btn :cssClass="{'btn': true, 'btn-secondary': !filters_changed, 'btn-success': filters_changed }" icon="fas fa-cog"></btn>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item command="create">New</el-dropdown-item>
                        <el-dropdown-item command="clone">Clone</el-dropdown-item>
                        <el-dropdown-item command="rename">Rename</el-dropdown-item>
                        <el-dropdown-item command="sharing_settings">Sharing Settings</el-dropdown-item>
                        <el-dropdown-item command="columns">Fields to display</el-dropdown-item>
                        <el-dropdown-item command="save-filters" :disabled="!filters_changed">Save Filters to List View</el-dropdown-item>
                        <el-dropdown-item command="discard-filters" :disabled="!filters_changed">Discard Filter Changes</el-dropdown-item>
                        <el-dropdown-item command="delete">Delete</el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>

                <slot name="buttons"></slot>
            </div>
        </div>

        <dialog-view-new :show="show_dialogs.create"
                         :table="table"
                        @updated="(view) => setView(view)"
                        @close="show_dialogs.create = false"
        ></dialog-view-new>
        <dialog-view-clone :show="show_dialogs.clone"
                           :view_id="view.id"
                           @updated="(view) => setView(view)"
                         @close="show_dialogs.clone = false"
        ></dialog-view-clone>
        <dialog-view-rename :show="show_dialogs.rename"
                           :view_id="view.id"
                           :name="view.name"
                           @updated="refresh"
                           @close="show_dialogs.rename = false"
        ></dialog-view-rename>
        <dialog-view-sharing-settings :show="show_dialogs.sharing_settings"
                            :view_id="view.id"
                            :availability="view.availability"
                            @updated="refresh"
                            @close="show_dialogs.sharing_settings = false"
        ></dialog-view-sharing-settings>

        <dialog-view-columns :show="show_dialogs.columns"
                        :columns="view.columns"
                        :available_columns="available_columns"
                        @updated="(columns) => setColumns(view, columns)"
                        @close="show_dialogs.columns = false"
        ></dialog-view-columns>
    </div>
</template>

<script>
import DialogViewNew from "./parts/dialog-view-new";
import DialogViewClone from "./parts/dialog-view-clone";
import DialogViewRename from "./parts/dialog-view-rename";
import DialogViewSharingSettings from "./parts/dialog-view-sharing-settings";
import DialogViewColumns from "./parts/dialog-view-columns";

export default {
    components: {DialogViewColumns, DialogViewSharingSettings, DialogViewRename, DialogViewClone, DialogViewNew},
    props: [
        'title',
        'table',
        'available_columns',
        'temp_filters'
    ],
    data() {
        return {
            show_dialogs: {
                create: false,
                clone: false,
                rename: false,
                columns: false,
                sharing_settings: false
            },

            dictionary: [],
            recent: [],
            alpha: [],

            selected_view_id: null,
            view: { id: null },
            filters_changed: false,

            uri: {
                pathname: '',
                title: '',
                search: null,
                view_id: null,
                filters: _.cloneDeep(this.temp_filters),
            }
        };
    },
    watch: {
        temp_filters() {
            let nonemptyTheirs = _.pickBy(this.temp_filters, (x) => x && (!Array.isArray(x) || x.length));
            let nonemptyMy = _.pickBy(this.view.filters, (x) => x && (!Array.isArray(x) || x.length));
            this.filters_changed = !_.isEqual(nonemptyTheirs, nonemptyMy);
        }
    },
    methods: {

        // actions
        touch(view) {
            return axios.post(url(`admin/views/touch`), { view_id: view.id }).then(() => this.refresh());
        },
        pin(view) {
            return axios.post(url(`admin/views/pin`), { view_id: view.id }).then(() => this.refresh());
        },
        unpin(view) {
            return axios.post(url(`admin/views/unpin`), { view_id: view.id }).then(() => this.refresh());
        },
        delete(view) {
            return this.$confirm('Are you sure? The list view will be deleted for all users', 'Delete List View', { confirmButtonText: 'Delete', cancelButtonText: 'Cancel' })
                .then(() => {
                    return axios.post(url(`admin/views/delete`), { view_id: view.id }).then(() => this.refresh());
                }).catch(() => {
                });
        },
        setColumns(view, columns) {
            return axios.post(url(`admin/views/set-columns`), { view_id: view.id, columns: columns })
                .then(() => {
                    this.refresh().then(() => { this.changeView(); });
                });
        },
        setFilters(view, filters) {
            return axios.post(url(`admin/views/set-filters`), { view_id: view.id, filters: filters })
                .then(() => {
                    this.refresh().then(() => { this.changeView(); });
                });
        },

        // UI changes
        settingsCommand(command) {
            if (command == 'create') {
                this.show_dialogs.create = true;
            }
            else if (command == 'clone') {
                this.show_dialogs.clone = true;
            }
            else if (command == 'rename') {
                this.show_dialogs.rename = true;
            }
            else if (command == 'sharing_settings') {
                this.show_dialogs.sharing_settings = true;
            }
            else if (command == 'columns') {
                this.show_dialogs.columns = true;
            }
            else if (command == 'save-filters') {
                this.setFilters(this.view, this.temp_filters);
            }
            else if (command == 'discard-filters') {
                this.changeView();
            }
            else if (command == 'delete') {
                this.delete(this.view);
            }
        },
        setView(view) {
            this.refresh().then(() => {
                this.selected_view_id = view.id;
                this.changeView();
            });
        },
        changeView(filtersOverwrite) {
            this.view = this.dictionary[this.selected_view_id];
            this.touch(this.view);
            this.changeUri();
            this.$emit('viewChanged', this.view.columns, (filtersOverwrite ? filtersOverwrite : this.view.filters), this.view.sort_by, this.view.sort_direction);
        },
        changeUri() {
            this.uri.search.set('view_id', this.selected_view_id);
            this.uri.search.delete('billing_type');
            this.uri.search.delete('billing_status');
            window.history.replaceState(null, this.uri.title, this.uri.pathname + '?' + this.uri.search.toString());
        },
        refresh() {
            return axios.get(url(`admin/views/data`), { params: { table: this.table}})
                .then((result) => {
                    this.dictionary = result.data.dictionary;
                    this.recent = result.data.recent;
                    this.alpha = result.data.alpha;

                    if (!this.selected_view_id) {
                        this.selected_view_id = result.data.default_view_id;
                    }
                    if (!this.dictionary[this.selected_view_id]) {
                        this.selected_view_id = _.head(this.alpha).id;
                    }
                    this.view = this.dictionary[this.selected_view_id];
                });
        }
    },
    mounted() {
        this.uri.pathname = window.location.pathname;
        this.uri.title = document.title;
        this.uri.search = new URLSearchParams(window.location.search.substring(1));

        if (this.uri.search.get('view_id') !== null) {
            this.uri.view_id = parseInt(this.uri.search.get('view_id'));
        }
        let filtersOverwrite = false;
        if (this.uri.search.get('billing_type') !== null) {
            filtersOverwrite = true;
            this.$set(this.uri.filters, 'billing_type', this.uri.search.get('billing_type').split(','));
        }
        if (this.uri.search.get('billing_status') !== null) {
            filtersOverwrite = true;
            this.$set(this.uri.filters, 'billing_status', this.uri.search.get('billing_status').split(','));
        }

        this.refresh().then(() => {
            if (this.uri.view_id !== null) this.selected_view_id = this.uri.view_id;
            this.changeView(filtersOverwrite ? this.uri.filters : null);
        });
    }
}
</script>
<style scoped>
    .el-dropdown-menu__item {
        padding: 0 20px;
    }
</style>